import {RouterModule, Routes} from '@angular/router';
import {OAuthCallbackComponent} from './services/oauth/oauth-callback.component';
import {UrlConsumerService} from './services/oauth/url-consumer.service';
import {LogoutComponent} from './components/routes/logout/logout.component';
import {AuthGuardService} from './services/oauth/auth-guard.service';
import {InboundComponent} from './components/routes/inbound/inbound.component';
import {ReceivingComponent} from './components/routes/inbound/receiving/receiving.component';
import {HasPrinterService} from './services/oauth/has-printer.service';
import {PartsMovementComponent} from './components/routes/inbound/parts-movement/parts-movement.component';
import {PackingComponent} from './components/routes/outbound/packing/packing.component';
import {NoAccessComponent} from './components/routes/no-access/no-access.component';
import {ModuleWithProviders} from '@angular/core';
import {WingsMobileComponent} from './wings-mobile.component';
import {HomePageComponent} from './components/routes/home-page/home-page.component';
import {AuditComponent} from './components/routes/audit/audit.component';
import {InConstructionComponent} from './components/routes/in-construction/in-construction.component';
import {ConferenceComponent} from "./components/routes/inbound/conference/conference.component";
import { CycleCountComponent } from './components/routes/cycle-count/cycle-count.component';
import { SettingsComponent } from './components/routes/settings/settings.component';
import { OutboundComponent } from './components/routes/outbound/outbound.component';
import { ManageWarehouseComponent } from './components/routes/manage-warehouse/manage-warehouse.component';
import { DenialComponent } from './components/routes/manage-warehouse/denial/denial.component';
import { DispatchingInvoicingComponent } from './components/routes/outbound/dispatching-invoicing/dispatching-invoicing.component';
import { PickingComponent } from './components/routes/outbound/picking/picking.component';

const routes: Routes = [
	{
		path: '',
		component: WingsMobileComponent,
		children: [
			{
				path: 'access_token',
				component: OAuthCallbackComponent,
				canActivate: [UrlConsumerService]
			},
			{
				path: '',
				redirectTo: 'home-page',
				pathMatch: 'full'
			},
			{
				path: 'logout',
				component: LogoutComponent
			},
			{
				path: 'home-page',
				component: HomePageComponent,
				canActivate: [AuthGuardService]
			},
			{
				path: 'cycle-count',
				component: CycleCountComponent,
				canActivate: [AuthGuardService]
			},
			{
				path: 'audit',
				component: AuditComponent,
				canActivate: [AuthGuardService]
			},
			{
				path: 'inbound',
				component: InboundComponent,
				canActivate: [AuthGuardService]
			},
			{
				path: 'receiving',
				component: ReceivingComponent,
				canActivate: [AuthGuardService, HasPrinterService]
			},
			{
				path: 'parts-movement',
				component: PartsMovementComponent,
				canActivate: [AuthGuardService]
			},
			{
				path: 'outbound',
				component: OutboundComponent,
				canActivate: [AuthGuardService]
			},
			{
				path: 'packing',
				component: PackingComponent,
				canActivate: [AuthGuardService]
			},
			{
				path: 'picking',
				component: PickingComponent,
				canActivate: [AuthGuardService]
			},
			{
				path: 'dispatchingandinvoicing',
				component: DispatchingInvoicingComponent,
				canActivate: [AuthGuardService, HasPrinterService]
			},
			{
				path: 'construction',
				component: InConstructionComponent,
				canActivate: [AuthGuardService]
			},
			{
				path: 'conference',
				component: ConferenceComponent,
				canActivate: [AuthGuardService]
			},
			{
				path: 'settings',
				component: SettingsComponent,
				canActivate: [AuthGuardService]
			},
			{
				path: 'no-access',
				component: NoAccessComponent
			},
			{
				path: 'manage-warehouse',
				component: ManageWarehouseComponent,
				canActivate: [AuthGuardService]
			},
			{
				path: 'denial',
				component: DenialComponent,
				canActivate: [AuthGuardService]
			}
		]
	}
];
export const routing: ModuleWithProviders<any> = RouterModule.forChild(routes)
